import { dialog } from "../../../../../nq-component";
import BaseFormPresenter from "../../../../../base/BaseFormPresenter";
import { findObjectUseCase } from "../../../../../usecases/object";
import DialogModal from "../../../../../components/Dialog";

class WasteRawFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async deductRaw({ storeId, rawSku, rawItemName, response, wasteQty }) {
    if (!storeId || !rawSku || !wasteQty) return;
    // console.log("WQWWW", rawSku, storeId);
    // // A) Find product (same sku + storeId)
    // const raw_materials = await findObjectUseCase().execute("raw_materials", {
    //   where: {
    //     sku: String(rawSku),
    //     // storeId: { id: storeId },
    //   },
    //   limit: 1,
    //   keys: ["id", "sku", "itemName", "quantity", "cost"],
    // });

    // console.log("pp", raw_materials);

    // const raw_material = Array.isArray(raw_materials) ? raw_materials[0] : null;

    // console.log("component", raw_material);

    // console.log("wasteQty", wasteQty);

    const deductQty = Number(wasteQty);
    console.log("deductQty", deductQty);
    // Find inventory row
    const inv = await findObjectUseCase().execute("inventory", {
      where: {
        // sku: raw_material?.sku,
        sku: String(rawSku),
        storeId: { id: storeId },
      },
      // keys: ["id", "sku", "", "storeId", "quantity"],
    });

    console.log("inv", inv);

    const invObj = Array.isArray(inv) ? inv[0] : null;
    console.log("pofbuObj", invObj);

    const current = Number(invObj.systemCount ?? 0);
    const nextQuantity = current - deductQty;

    console.log("Update INV:", {
      id: invObj.id,
      quantity: nextQuantity,
    });

    // Update pofb row
    await this.upsertUseCase.execute("inventory", {
      id: invObj.id,
      systemCount: String(nextQuantity),
    });

    await this._saveReceivableTransaction({
      storeId: { id: storeId },
      sku: rawSku,
      item_name: rawItemName,
      transaction_type: "Waste",
      quantity: String(-deductQty),
      business_date: new Date().toISOString(),
      reference_id: response?.id,
    });
  }

  async _saveReceivableTransaction(inventoryItem) {
    try {
      // const payload = {
      //   storeId: { id: storeId },
      //   sku: material.sku,
      //   item_name: material.itemName,
      //   transaction_type: "Direct Purchase",
      //   quantity: String(material.quantity),
      //   business_date: new Date().toISOString(),
      //   reference_id: directPurchaseResponse?.id,
      // };

      await this.upsertUseCase.execute("inventory_transaction", inventoryItem);
    } catch (error) {
      throw error;
    }
  }

  async save() {
    this.view.showProgressDialog();
    const collection = this.view.getCollectionName();
    const user = this.view.getCurrentUser();
    const storeId = user?.storeAnalytic?.[0]?.id;

    const base = {};
    if (this.object?.id) {
      base.id = this.object.id;
    } else {
      base.acl = this.view.getAcl();
      base.storeId = { id: storeId };
      // base.category = "raw_materials";
    }

    const items = this.change?.items || this.object?.items || [];

    // 1) Build one payload per item (breakdown)
    const payloads = (Array.isArray(items) ? items : []).map((it) => ({
      ...base,
      product: it.product || null,
      name: it.itemName || it.name || "",
      sku: it.sku || "",
      amount: String(it.cost ?? it.amount ?? 0),
      quantity: String(it.quantity ?? 0),
      description: it.description || "",
      wasteType: "Manual Waste" || "POS Waste",
      category: it.category,
      voidDate: new Date().toISOString(),
      isUpsale: false,
    }));

    try {
      // 2) Save each waste record
      for (const payload of payloads) {
        delete payload.product;
        const response = await this.upsertUseCase.execute(collection, payload);

        // 3) After  save: deduct raw materials for this waste line
        await this.deductRaw({
          storeId,
          rawSku: payload.sku,
          rawItemName: payload.itemName,
          response: response.id,
          wasteQty: payload.quantity,
        });
      }

      this.change = {};
      this.view.hideProgressDialog();
      dialog.fire({
        html: (
          <DialogModal
            icon="bi bi-question-octagon-fill"
            iconColor="#82c14a"
            title="Saved Successfully"
            message=""
            isCancelButton={false}
            onSubmit={() => {
              dialog.close();
              this.view.navigateBack();
            }}
            onClose={() => dialog.close()}
          />
        ),
        footer: false,
      });
    } catch (error) {
      throw error;
    }
  }

  async submit() {
    if (Object.values(this.change).length === 0) {
      this.view.showSuccessSnackbar("Successfully saved!");
      return;
    }
    try {
      this.view.submitting();
      dialog.close();
      await this.save();
      // this.view.submissionSuccess();
      // this.view.showSuccessSnackbar("Successfully saved!");
      // this.view.navigateBack();
    } catch (error) {
      this.view.submissionError(error);
      this.view.showError(error);
    }
  }
}

export default WasteRawFormPresenter;
